import { takeUntil } from 'rxjs/operators';
import { UnsubscribeOnDestroy } from 'src/app/_helpers/unsubscribe-on-destroy';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ConfirmarCorreoService } from '../_services/confirmar-correo.service';
import { NotificationI18nService } from '../core/util/notification-i18n.service';

@Component({
  selector: 'app-confirmar-correo',
  templateUrl: './confirmar-correo.component.html',
  styleUrls: ['./confirmar-correo.component.css']
})
export class ConfirmarCorreoComponent extends UnsubscribeOnDestroy implements OnInit{

  constructor(
    private _route: ActivatedRoute,
    private _confirmarCorreo: ConfirmarCorreoService,
    private _notificationI18n: NotificationI18nService
  ){
    super();
  }
  
  identificador: string = '';
  identificadorCorrecto: string = '';
  blockEnvioCorreo: boolean = false;

  ngOnInit(): void {
    this.obtenerIdentificador();
  }

  obtenerIdentificador() {
    this._route.params
      
        .pipe(takeUntil(this.destroy$))
        .subscribe(params => {
        this.identificador = params['identificador'];
        this._confirmarCorreo.checkIdentificador(this.identificador)
          .pipe(takeUntil(this.destroy$))
          .subscribe({
          next: (data) => {
            this.identificadorCorrecto = 'valido';
          },
          error: (error) => {
            console.error(error);
            
            if(error.error.responseCode == '644'){
              this.identificadorCorrecto = 'caducado';
            }
            if(error.error.responseCode == '643'){
              this.identificadorCorrecto = 'incorrecto';
            }
          }
        })
      }
    );
  }

  reenviarCorreo(){
    this.blockEnvioCorreo = true;
    this._confirmarCorreo.reenviarCorreo(this.identificador)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
      next: (data) => {
        this._notificationI18n.info('NOTIFICATION.MESSAGE.SE_HA_ENVIADO_EL_EMAIL_DE_CONFIRMACION_A_SU_CUENTA_DE_CORREO');
        this.blockEnvioCorreo = false;
      },
      error: (error) => {
      }
    })
  }

}
